import { useConfiguratorPageViewModel } from "~/features/configurator/common/hooks/useConfiguratorPageViewModel";
import { ConfiguratorPage } from "~/features/configurator/common/components/ConfiguratorPage";
import {
  ConfiguratorPageCustomizationContext,
  type ConfiguratorPageCustomization,
} from "~/features/configurator/common/components/ConfiguratorPageCustomizationContext";
import CircleSpinner from "~/common/components/CircleSpinner/CircleSpinner";
import { Typography } from "~/common/mui";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";

const DEFAULT_CUSTOMIZATION: ConfiguratorPageCustomization = {
  showRegistrationBanner: true,
  showPrice: true,
  showAvailability: true,
  forceShowCAD: false,
  showSave: true,
  embedded: false,
  showDownloadPDF: true,
  showRequestQuotation: true,
  showContactSpecialistLink: true,
  specialistLinkURL: URL_CONTACT_US,
};

export function ConfiguratorPageEntry({ productCode }: { productCode: string }) {
  const viewModel = useConfiguratorPageViewModel(productCode);

  if (viewModel.isLoading) {
    return <CircleSpinner />;
  }

  if (viewModel.error || !viewModel.configDefinition) {
    return <Typography variant="bodyMedium">{viewModel.error ?? "No configurator definition available!"}</Typography>;
  }

  const customization = viewModel.customization ?? DEFAULT_CUSTOMIZATION;

  return (
    <ConfiguratorPageCustomizationContext.Provider value={customization}>
      <ConfiguratorPage config={viewModel.configDefinition} />
    </ConfiguratorPageCustomizationContext.Provider>
  );
}
